import Node from './node';

export default class Info extends Node {
  clone() {
    return new Info(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
